import { render } from "./BellNotification.vue?vue&type=template&id=d063faa2"
import script from "./BellNotification.vue?vue&type=script&lang=js"
export * from "./BellNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__